import React, { useState, useRef } from "react";
import { Row, Col, Button, Popover, Overlay } from "react-bootstrap";
import useAdminAuth from "../hooks/UseAdminAuth";
import "../styles/headerAdm.css";

function HeaderAdm({ handleShow }) {
  const { admin, logout } = useAdminAuth();
  const [showPopover, setShowPopover] = useState(false);
  const iconRef = useRef(null); 

  const handleTogglePopover = () => setShowPopover(!showPopover);
  const handleClosePopover = () => setShowPopover(false);
  const handleLogout = () => logout();

  return (
    <Row
      className="d-flex align-items-center py-2 p-md-3"
      id="header-container-admin"
    >
      <Col
        xs={6}
        className="d-flex justify-content-start d-md-none align-items-center"
      >
        <Button variant="btn btn-outline-light text-dark" onClick={handleShow}>
          <i className="bi bi-list"></i>
        </Button>
      </Col>
      <Col
        xs={6}
        md={12}
        className="d-flex justify-content-end align-items-center"
      >
        <p
          className="admin-name mb-0 me-2 d-none d-sm-block"
          onClick={handleTogglePopover}
          ref={iconRef}
        >
          {admin.name}
        </p>
        <i
          className="bi bi-person-circle me-2 me-md-0"
          onClick={handleTogglePopover}
          ref={iconRef}
        ></i>
      </Col>

      <Overlay
        show={showPopover}
        target={iconRef.current}
        placement="bottom-end"
        rootClose
        onHide={handleClosePopover}
      >
        <Popover id="popover-contained-admin">
          <Popover.Header as="h3" className="popover-header-admin">
            Admin Profile
          </Popover.Header>
          <Popover.Body className="popover-body-admin">
            <p className="mb-1">
              <strong>{admin.name}</strong>
            </p>
            <p className="mb-3">{admin.email}</p>
            <Button
              variant="danger"
              size="sm"
              className="w-100 fw-bold"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-left"></i> Sign out
            </Button>
          </Popover.Body>
        </Popover>
      </Overlay>
    </Row>
  );
}

export default HeaderAdm;
